import { defineMessages } from 'react-intl';

export default defineMessages({
    appName: {
        id: 'portal.name',
        defaultMessage: 'CustomerEngage Account Management'
    },
    account: {
        id: 'portal.index.Account',
        defaultMessage: 'Account'
    },
    faq: {
        id: 'portal.index.FAQ',
        defaultMessage: 'FAQ'
    },
    home: {
        id: 'app.html.index.Home',
        defaultMessage: 'Home'
    },
    logout: {
        id: 'portal.index.Logout',
        defaultMessage: 'Logout'
    },
    additionalEnrollment: {
        id: 'portal.index.Additional Enrollment',
        defaultMessage: 'Additional Enrollment'
    },
    makeAPayment: {
        id: 'portal.index.Make a Payment',
        defaultMessage: 'Make a Payment'
    },
    billingSummary: {
        id: 'portal.index.Billing',
        defaultMessage: 'Billing'
    },
    claimList: {
        id: 'portal.index.Claims',
        defaultMessage: 'Claims'
    },
    claimDetails: {
        id: 'portal.index.Claim Details',
        defaultMessage: 'Claim Details'
    },
    createNote: {
        id: 'portal.index.Create Note',
        defaultMessage: 'Create Note'
    },
    policyChange: {
        id: 'portal.index.Policy Change',
        defaultMessage: 'Policy Change'
    },
    policyDetails: {
        id: 'portal.index.Policy Details',
        defaultMessage: 'Policy Details'
    },
    accountInformation: {
        id: 'portal.index.Account Information',
        defaultMessage: 'Account Information'
    },
    homePage: {
        id: 'portal.index.Home Page',
        defaultMessage: 'Home Page'
    },
    error: {
        id: 'portal.index.Error',
        defaultMessage: 'Error'
    },
    errorMessage: {
        id: 'portal.index.Sorry, an error occurred. You can try later or contact one of our agents.',
        defaultMessage: 'Sorry, an error occurred. You can try later or contact one of our agents.'
    },
    backButton: {
        id: 'portal.index.Back',
        defaultMessage: 'Back'
    },
    resources: {
        id: 'portal.index.Resources',
        defaultMessage: 'Resources'
    },
    payrollReporting: {
        id: 'portal.index.Payroll Reporting',
        defaultMessage: 'Payroll Reporting'
    },
    userAdministration: {
        id: 'portal.index.User Administration',
        defaultMessage: 'User Administration'
    },
    certificatesOfInsurance: {
        id: 'portal.index.Certificates of Insurance',
        defaultMessage: 'Certificates of Insurance'
    },
    footerCopperpointText: {
        id: "portal.index.CopperPoint Insurance Companies",
        defaultMessage: "CopperPoint Insurance Companies"
    },
    footerlinkedInText: {
        id: "portal.index.LinkedIn",
        defaultMessage: "LinkedIn"
    },
    
});
